import {
    AssetGroup,
    AssetGroupAssociationData,
    AssetGroupUpdateData,
} from '@app/shared/models/asset-group.model';
import { HttpClient } from '@angular/common/http';
import { AssetGroupAssociation } from '@core/utils/asset-group/asset-group-association';

export class DeleteAGAssociation extends AssetGroupAssociation {
    action = 'DELETE';
    data: AssetGroupUpdateData;

    constructor(
        httpClient: HttpClient,
        assetGroup: AssetGroup,
        originalList: AssetGroup[],
        updatedList: AssetGroup[]
    ) {
        super(httpClient);
        this.data = this.getData(assetGroup, originalList, updatedList);
    }

    getAssociationPayload(): AssetGroupAssociationData {
        const ancestors = super.getAncestorsIds(
            this.data.assetGroup.original,
            this.data.hierarchy.original,
            []
        );
        const children = super.getChildrenIds(
            this.data.assetGroup.original,
            this.data.hierarchy.original,
            []
        );

        return {
            refAssetGroup: this.data.assetGroup.original.id,
            action: this.action,
            lineageFrom: [...ancestors, this.data.assetGroup.original.id, ...children],
            lineageTo: [...ancestors, ...children],
        };
    }
}
